import { organization } from './organization';

export const common = {
  search: {
    placeholder: { en: 'search by name', ko: '이름을 입력하세요.', fr: '' },
    pageSize: { en: 'Show rows per page', ko: '페이지당 줄 개수', fr: '' },
    notFound: { en: 'Not specified', ko: '검색 결과가 없습니다.', fr: '' },
  },
  select: {
    organization: { en: 'Organization', ko: '조직 선택', fr: '' },
    distributor: { en: 'Distributor', ko: '대리점 선택', fr: '' },
    category: { en: 'Category', ko: '카테고리 선택', fr: '' },
    gender: { en: 'Select Sex', ko: '성별 선택', fr: '' },
    type: { en: 'Select Type', ko: '유형 선택', fr: '' },
    sub: { en: 'Select Sub', ko: '서브 선택', fr: '' },
    listMaxCount: { en: 'max count', ko: '보기설정', fr: '' },
    groupCode: { en: 'Group Code', ko: '그룹코드', fr: '' },
    model: { en: 'model', ko: '모델 선택', fr: '' },
    timeZone: { en: 'timezone', ko: '시간대 선택', fr: '' },
    manifest: { en: 'manifest', ko: '매니페스트 선택', fr: '' },
    all: { en: 'Select All', ko: '전체 선택', fr: '' },
    allShortForm: { en: 'All', ko: '전체', fr: '' },
    region: { en: 'Region', ko: '지역 선택', fr: '' },
    city: { en: 'City', ko: '도시 선택', fr: '' },
    service: { en: 'Service', ko: '서비스 선택', fr: '' },
    defaultPage: { en: 'Select Default page', ko: '초기 화면 선택', fr: '' },
    active: { en: 'Active', ko: '활성' },
    inactive: { en: 'Inactive', ko: '비활성' },
    hospital: { en: 'Hospital', ko: '병원' },
    myPatient: { en: 'My Patients', ko: '내 환자' },
  },
  buttons: {
    edit: { en: 'Edit', ko: '수정', fr: '' },
    editRHF: { en: 'EditRHF', ko: '수정_2', fr: '' },
    delete: { en: 'Delete', ko: '삭제', fr: '' },
    add: { en: 'Add', ko: '추가', fr: '' },
    save: { en: 'Save', ko: '저장', fr: '' },
    cancel: { en: 'Cancel', ko: '취소', fr: '' },
    search: { en: 'Search', ko: '검색', fr: '' },
    selectFile: { en: 'choose File', ko: '파일 선택', fr: '' },
    registration: { en: 'Registration', ko: '등록', fr: '' },
    register: { en: 'Register', ko: '등록', fr: '' },
    registrationRHF: { en: 'Registration_2', ko: '등록_2', fr: '' },
    next: { en: 'next', ko: '다음', fr: '' },
    ok: { en: 'OK', ko: '확인', fr: '' },
    doubleCheck: { en: 'Duplicate check', ko: '중복확인', fr: '' },
    close: { en: 'Close', ko: '닫기', fr: '' },
    confirm: { en: 'Confirm', ko: '확인', fr: '' },
    detail: { en: 'Details', ko: '상세정보', fr: '' },
    resetPWD: { en: 'Password reset', ko: '비밀번호 재설정', fr: '' },
    changePWD: { en: 'Change password', ko: '비밀번호 변경', fr: '' },
    submitting: { en: 'Sending', ko: '전송중', fr: '' },
    submit: { en: 'Send', ko: '전송', fr: '' },
    mergePatients: { en: 'Merge Patients', ko: '환자 병합', fr: '' },
    merge: { en: 'Merge', ko: '병합', fr: '' },
    approve: { en: 'Approve', ko: '승인', fr: '' },
    revoke: { en: 'Revoke', ko: '반려', fr: '' },
    cancelApprove: { en: 'Cancel Approve', ko: '승인 취소', fr: '' },
    cancelOrder: { en: 'Cancel Order', ko: '주문 취소', fr: '' },
    downloadReport: { en: 'Download Report', ko: '보고서 다운로드', fr: '' },
    downloadCSV: { en: 'Download CSV', ko: 'CSV 다운로드', fr: '' },
    bulkRegistration: { en: 'Bulk Registration', ko: '대용량 등록', fr: '' },
    downloadTemplate: { en: 'Download template', ko: '템플릿 다운로드', fr: '' },
    selectCSV: { ko: 'CSV 파일 선택', en: 'Choose CSV file' },
    downloadTotalDataAsCSV: { en: 'Download All Data as CSV', ko: '전체 데이터 CSV 다운로드', fr: '' },
    patientList: { en: 'Patient List', ko: '환자 목록', fr: '' },
    apply: { en: 'Apply', ko: '적용', fr: '' },
  },
  words: {
    account: { en: 'Account', ko: '내 계정', fr: '' },
    logout: { en: 'Logout', ko: '로그아웃', fr: '' },
    login: { en: 'Login', ko: '로그인', fr: '' },
    download: { en: 'Download', ko: '다운로드', fr: '' },
    rows: { en: ' rows', ko: ' 행', fr: '' },
    preference: { en: 'setting', ko: '설정', fr: '' },
    frontReload: { en: 'Reload Meerkat', ko: '미어캣 리로드', fr: '' },
    reload: { en: 'Reload', ko: '리로드', fr: '' },
    average: { en: 'Average', ko: '평균' },
    currentPage: { en: 'Current Page', ko: '현재 페이지' },
    success: { en: 'Success', ko: '성공' },
    failed: { en: 'Failed', ko: '실패' },
    status: { en: 'Status', ko: '상태' },
    message: { en: 'Message', ko: '메시지' },
    preview: { en: 'Preview', ko: '미리보기' },
  },
  errors: {
    INFO_0001: { en: 'result does not exist', ko: '조회 결과가 존재하지 않습니다.', fr: '' },
    INFO_0002: { en: 'validation Failed', ko: '유효성 검사 실패', fr: '' },
    INFO_0003: { en: 'member.ts does not exist', ko: '존재하지 않는 회원입니다.', fr: '' },
    INFO_0004: { en: 'passwords do not match', ko: '비밀번호가 일치하지 않습니다.', fr: '' },
    INFO_0005: { en: 'you do not have permission', ko: '권한이 없습니다.', fr: '' },
    INFO_0009: { en: 'patientManageId is already connected', ko: '이미 연결된 장비관리ID 입니다.', fr: '' },
    INFO_0010: { en: 'No file selected.', ko: '선택된 파일이 없습니다.', fr: '' },
    INFO_0011: { en: 'CSV file is empty.', ko: 'CSV 파일에 데이터가 없습니다.', fr: '' },
    ERROR_0001: { en: 'failed to parsing JSON', ko: 'JSON 파싱 실패', fr: '' },
    ERROR_0002: {
      en: 'access is denied because token is expired. ',
      ko: '토큰만료로 인하여 접근이 거부되었습니다.',
      fr: '',
    },
    ERROR_0003: { en: 'failed to update. count: 0 ', ko: 'UPDATE COUNT 이상', fr: '' },
    ERROR_1000: { en: 'serial number is already registered', ko: '이미 등록된 시리얼번호 입니다.', fr: '' },
    ERROR_9000: { en: 'other system errors', ko: '기타 시스템 오류', fr: '' },
  },
  confirm: {
    delete: { en: 'Are you sure you want to delete it?', ko: '삭제하시겠습니까?', fr: '' },
    deleteConnectedDevice: {
      en: 'Devices connected to this patient will be disconnected as of today.',
      ko: '이 환자에게 연결된 기기는 오늘 날짜로 연결이 종료됩니다.',
      fr: '',
    },
    cannotDeletePatientTitle: { en: 'Cannot delete patient', ko: '환자를 삭제할 수 없습니다', fr: '' },
    deleteBlockedByConnectedDevice: {
      en: 'This patient has a connected device. Disconnect the device first, then the patient can be deleted.',
      ko: '이 환자에게 연결된 장치가 있습니다. 장치 연결을 해제한 후 삭제할 수 있습니다.',
      fr: '',
    },
    changePWD: {
      en: 'Do you want to change password? It will be reflected immediately upon confirmation.',
      ko: '비밀번호를 변경하시겠습니까? 확인 시 바로 반영됩니다.',
      fr: '',
    },
    disconnect: { en: 'Are you sure you want to disconnect device', ko: '기기와 연결을 해제하시겠습니까?', fr: '' },
    connect: { en: 'Are you sure you want to connect device', ko: '기기와 연결하시겠습니까?', fr: '' },
    mergePatient: { en: 'Are you sure you want to merge the two patients?', ko: '두 환자를 병합하시겠습니까?', fr: '' },
    mergeAlert: { en: 'Tow patients have already been selected.', ko: '병합할 환자 두 명이 선택되었습니다.' },
    cancelApprove: { en: 'Are you sure you want to cancel approve', ko: '승인을 취소하시겠습니까?', fr: '' },
    cancelOrder: { en: 'Are you sure you want to cancel order', ko: '주문을 취소하시겠습니까?', fr: '' },
    changePatient: {
      en: 'Are you sure you want to disconnect the device from the current patient and connect it to a new patient?',
      ko: '기존 연결을 해제하고 새로운 환자에게 연결하시겠습니까?',
      fr: '',
    },
    deleteMapping: {
      en: 'Are you sure you want to delete the patient device history?',
      ko: '환자 장치 이력을 삭제하시겠습니까?',
      fr: '',
    },
  },
  drawer: {
    passwordChange: { en: 'Change password', ko: '비밀번호 변경', fr: '' },
  },
  gender: {
    F: { en: 'Female', ko: '여', fr: '' },
    M: { en: 'Male', ko: '남', fr: '' },
    O: { en: 'Other', ko: '기타', fr: '' },
  },
  message: {
    underConstruction: { en: 'This page is under construction', ko: '페이지 준비 중입니다', fr: '' },
    betterService: {
      en: 'We’re working hard to bring you a better service.',
      ko: '더 나은 서비스를 위해 해당 페이지를 준비하고 있습니다.',
      fr: '',
    },
    backSoon: {
      en: 'We’ll be back soon!',
      ko: '곧 다시 찾아뵙겠습니다!',
      fr: '',
    },
    loadingPdf: { en: 'Preparing report', ko: '보고서 준비중입니다.' },
    wait: { en: 'Please wait for a moment.', ko: '잠시만 기다려주세요.' },
    processPdf: { en: 'Generating report', ko: '보고서 생성 중입니다.' },
    accessDenied: { en: 'Access Denied', ko: '접근할 수 없습니다' },
    checkTemplate: {
      en: 'Download the example CSV to check the format.',
      ko: '예시 CSV를 내려받아 형식을 확인하세요.',
    },
  },
};
